export default __webpack_public_path__ + "static/media/Logo-Effe.5188116c.png";